import MyToastShow from "@/components/Layout/MyToast";
import ModalAgruparCarritos from "@/components/Modals/ModalAgruparCarritos";
import ModalBorrarCarrito from "@/components/Modals/ModalBorrarCarrito";
import ModalEliminarInforme from "@/components/Modals/ModalEliminarInforme";
import ModalFactura from "@/components/Modals/ModalFactura/ModalFactura";
import ModalInformado from "@/components/Modals/ModalInformado";
import ModalInforme from "@/components/Modals/ModalInforme";
import ModalLiquidarCarpetas from "@/components/Modals/ModalLiquidarCarpetas";
import ModalLiquidarCarrito from "@/components/Modals/ModalLiquidarCarrito";
import ModalLiquidarInformes from "@/components/Modals/ModalLiquidarInformes";
import ModalObservarCarpeta from "@/components/Modals/ModalObservarCarpeta";
import ModalPagarCarpetas from "@/components/Modals/ModalPagarCarpetas";
import ModalPagarCarrito from "@/components/Modals/ModalPagarCarrito";
import ModalRechazarInforme from "@/components/Modals/ModalRechazarInforme";
import ModalVerNotas from "@/components/Modals/ModalVerNotas";
import { Suspense } from "react";
import { useEditarInformeMutation, useImprimirInformeMutation } from "@/redux/api/informeApi";
import { estadoGeneralCarrito, ICarrito, IInforme, isICarrito, isIInforme } from "@/redux/models";
import { useTablaCarpetaContext } from "../logics/TablaCarritoProvider";

export type modalsTypes = modalCarpetaType | modalInformeType;

export enum modalInformeType {
    VER_INFORME = 'ver_informe',
    EDITAR_INFORME = 'editar_informe',
    GESTIONAR_INFORMADO = 'gestionar_informado',
    ELIMINAR_INFORME = 'eliminar_informe',
    LIQUIDAR_INFORMES = 'liquidar_informes',
    RECHAZAR_INFORME = 'rechazar_informe',
}
export enum modalCarpetaType {
    PAGAR_CARPETAS = 'pagar_carpetas',
    AGRUPAR_CARPETAS = 'agrupar_carpetas',
    LIQUIDAR_CARPETA = 'liquidar_carpeta',
    LIQUIDAR_CARPETAS = 'liquidar_carpetas',
    PAGAR_CARPETA = 'pagar_carpeta',
    FACTURAR_CARPETA = 'facturar_carpeta',
    BORRAR_CARPETA = 'borrar_carpeta',
    NOTAS_CARPETA = 'notas_carpeta',
    VER_NOTAS_CARPETA = 'ver_notas_carpeta',
}

const Modals = () => {
    const { context: { isForEmpresa: liquidacionPorEmpresa, modal, setModal, selectedCarritos, modificarInforme, borrarInforme, borrarCarpeta, modificarCarpeta, modificarCarpetaById, refetchCarpetas, setSelectedCarritos, informes } } = useTablaCarpetaContext();
    const [editarInforme] = useEditarInformeMutation();
    const [imprimirInforme] = useImprimirInformeMutation();

    const handleEditarInforme = (informe: IInforme) => {
        editarInforme(informe).unwrap()
            .then((newInforme) => {
                MyToastShow({ message: 'Informe editado correctamente', type: 'success' });
                setModal('');
                modificarInforme(newInforme);
            })
            .catch(() => {
                MyToastShow({ message: 'Error al editar el informe', type: 'error' });
            });
    }

    const handleMarcarImpreso = (informe: IInforme) => {
        const nuevoEstado = true;
        imprimirInforme({ id: informe.id, printed: nuevoEstado }).unwrap().then((res) => {
            modificarInforme({ ...informe, printed: nuevoEstado })
            MyToastShow({ message: `${informe.printed ? 'Desm' : 'M'}arcado como impreso`, type: "success" })

        }).catch((err) => {
            MyToastShow({ message: "Error al marcar como impreso", type: "error" })
        })
    }


    const renderModal = () => {
        switch (modal.type) {
            case modalCarpetaType.PAGAR_CARPETAS:
                return (

                    <ModalPagarCarpetas
                        open={true}
                        onCancel={() => setModal('')}
                        carpetas={selectedCarritos}
                        onCarpetasPagadas={(carpetas) => { }}
                    />

                );
            case modalCarpetaType.AGRUPAR_CARPETAS:
                return (
                    <ModalAgruparCarritos
                        open={true}
                        onCancel={() => setModal('')}
                        carpetas={selectedCarritos}
                        onCarpetasAgrupadas={() => {
                            refetchCarpetas()
                            setModal('')
                            setSelectedCarritos([])
                        }}
                    />
                )
            case modalCarpetaType.LIQUIDAR_CARPETA: return (
                <ModalLiquidarCarrito
                    open={true}
                    onCancel={() => setModal('')}
                    onCarritoLiquidado={modificarCarpeta}
                    carrito={isICarrito(modal.data) ? modal.data : {} as ICarrito}
                />
            );
            case modalCarpetaType.LIQUIDAR_CARPETAS: return (
                <ModalLiquidarCarpetas
                    isCarritosEmpresa={liquidacionPorEmpresa}
                    open={true}
                    onCancel={() => setModal('')}
                    carpetas={selectedCarritos}
                    onCarpetasLiquidados={(carpetas) => {
                        refetchCarpetas()
                    }}
                />
            );
            case modalCarpetaType.PAGAR_CARPETA:
                return (
                    <ModalPagarCarrito
                        open={true}
                        onCancel={() => setModal('')}
                        carrito={modal.data as ICarrito}
                        onCarritoPagado={modificarCarpeta}
                    />
                );
            case modalCarpetaType.FACTURAR_CARPETA:
                return (
                    <ModalFactura
                        open={true}
                        onCancel={() => setModal('')}
                        carpeta={modal.data as ICarrito | undefined}
                        onSubmit={(c) => { modificarCarpeta(c); setModal(''); }}
                    />
                );
            case modalCarpetaType.BORRAR_CARPETA:
                const carritoToDelete = modal?.data as ICarrito || undefined;
                const informesToDelete = carritoToDelete ? informes[carritoToDelete.idCarrito] || [] : [];
                return (
                    <ModalBorrarCarrito
                        open={true}
                        onCancel={() => setModal('')}
                        carrito={carritoToDelete}
                        informes={informesToDelete}
                        onCarritoBorrado={(carrito) => {
                            // Añadir un delay para sincronizar con la animación del modal
                            setTimeout(() => {
                                borrarCarpeta(carrito);
                                setModal('');
                                setSelectedCarritos([]);
                            }, 300);
                        }}
                    />
                );
            case modalCarpetaType.NOTAS_CARPETA:
                return (<ModalObservarCarpeta
                    open={true}
                    onCancel={() => setModal('')}
                    carpeta={modal?.data as ICarrito || undefined}
                    onCarpetaObservada={modificarCarpeta}
                />)
            case modalCarpetaType.VER_NOTAS_CARPETA:
                return (<ModalVerNotas
                    open={true}
                    onCancel={() => setModal('')}
                    carpeta={modal?.data as ICarrito || undefined}
                />)
            case modalInformeType.VER_INFORME:
            case modalInformeType.EDITAR_INFORME:
                return (
                    <ModalInforme
                        mode={modal.type === modalInformeType.EDITAR_INFORME ? 'editable' : 'admin-view'}
                        open={true}
                        informe={isIInforme(modal.data) ? modal.data : undefined}
                        onClose={() => setModal('')}
                        onSubmit={(i) => handleEditarInforme(i)}
                        onPrinted={handleMarcarImpreso}
                    />
                );
            case modalInformeType.LIQUIDAR_INFORMES:
                return (
                    <ModalLiquidarInformes
                        open={true}
                        onCancel={() => setModal('')}
                        onInformesLiquidados={({ informes }) => informes.forEach(modificarInforme)}
                        carrito={modal.data.carrito}
                        informes={modal.data.informes}
                    />
                )

            case modalInformeType.GESTIONAR_INFORMADO:
                return (
                    <ModalInformado
                        open={true}
                        informe={isIInforme(modal.data) ? modal.data : undefined}
                        onInformado={(informe) => {
                            modificarInforme(informe)
                            modificarCarpetaById({ idCarrito: informe.idCarrito, estadoGeneral: estadoGeneralCarrito['Informada'] })
                        }}
                        onCancel={() => setModal('')}
                    />
                );
            case modalInformeType.ELIMINAR_INFORME:
                return (
                    <ModalEliminarInforme
                        open={true}
                        onCancel={() => setModal('')}
                        informe={isIInforme(modal.data) ? modal.data : undefined}
                        onInformeBorrado={borrarInforme}
                    />
                );
            case modalInformeType.RECHAZAR_INFORME:
                return (
                    <ModalRechazarInforme
                        open={true}
                        onCancel={() => setModal('')}
                        informe={isIInforme(modal.data) ? modal.data : undefined}
                        onInformeRechazado={(informe) => {
                            modificarInforme(informe)
                            refetchCarpetas()
                        }}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <Suspense fallback={<div>Loading...</div>}>
            {renderModal()}
        </Suspense>
    );
}

export default Modals;
